import React from "react";
import { Form, Flex, theme } from "antd";
import { HeaderApp } from "../../shared";
import { useCreateConcept } from "../hooks/useCreateConcept";
import type { ConceptData } from "../types";
import openNotification from "../../../utils/openNotification";
import { useNavigate } from "react-router-dom";
import ConceptForm from "../components/ConceptForm";

const NewConcept: React.FC = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const { mutate: createConceptMutation, isPending: isCreating } = useCreateConcept();
  const navigate = useNavigate();

  const handleFinish = async (values: ConceptData) => {
    createConceptMutation(values, {
      onSuccess: () => {
        form.resetFields();
        navigate('/catalogo/conceptos');
        openNotification('success', 'Concepto creado exitosamente');
      },
      onError: (error) => {
        openNotification('error', 'Error', error.message);
      }
    });
  };

  return (
    <Flex
      vertical
      style={{
        background: token.colorBgLayout,
      }}
    >
      <HeaderApp sectionName="Agregar Nuevo Concepto" showBack />

      <Flex
        vertical
        gap={28}
        style={{
          maxWidth: 640,
          width: "100%",
          margin: "0 auto",
          padding: "28px 24px 100px",
        }}
      >
        <ConceptForm 
            form={form} 
            onFinish={handleFinish} 
            isPending={isCreating} 
            buttonText="Guardar Concepto" 
            formId="new-concept-form"
        />
      </Flex>
    </Flex>
  );
};

export default NewConcept;
